import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Card, CardContent, CardHeader, Avatar, Typography, TextField, Button, Grid } from '@mui/material';
import axios from 'axios';

export default function UpdateCompany() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const { id, name, address, email, phoneNumber, website } = state;

  const [companyName, setCompanyName] = useState(name || '');
  const [companyAddress, setCompanyAddress] = useState(address || '');
  const [companyEmail, setCompanyEmail] = useState(email || '');
  const [companyPhone, setCompanyPhone] = useState(phoneNumber || '');
  const [companyWebsite, setCompanyWebsite] = useState(website || '');

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  const updateAPIData = () => {
    axios.put(`${SERVER_URL}/api/companies/${id}`, {
      name: companyName,
      address: companyAddress,
      email: companyEmail,
      phoneNumber: companyPhone,
      website: companyWebsite
    }).then(() => {
      navigate('/dashboard/CompaniesListAll'); // vraća na listu firmi
    });
  };

  return (
    <div style={{
      backgroundColor: '#001536',
      minHeight: '100vh',
      width: '100%',
      padding: '20px'
    }}>
      <Grid container justifyContent="center">
        <Card sx={{ maxWidth: 600, width: '100%', backgroundColor: '#00122E', color: '#ff9800', borderRadius: 2, boxShadow: 3 }}>
          <CardHeader
            avatar={<Avatar sx={{ width: 60, height: 60 }}>{name ? name[0] : "F"}</Avatar>}
            title={<Typography variant="h6">{name}</Typography>}
            subheader={<Typography variant="body2">{email}</Typography>}
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Naziv firme"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                  required
                />
                <TextField
                  label="Adresa"
                  value={companyAddress}
                  onChange={(e) => setCompanyAddress(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
                <TextField
                  label="Email"
                  type="email"
                  value={companyEmail}
                  onChange={(e) => setCompanyEmail(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
                <TextField
                  label="Telefon"
                  value={companyPhone}
                  onChange={(e) => setCompanyPhone(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
                <TextField
                  label="Web stranica"
                  value={companyWebsite}
                  onChange={(e) => setCompanyWebsite(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ff9800' } }}
                  InputProps={{ style: { color: '#ff9800' } }}
                />
              </Grid>
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
              <Button variant="outlined"
                sx={{
                  minWidth: 100,
                  backgroundColor: '#001B44',
                  color: '#ff9800',                // 🔥 tekst orange
                  border: '1px solid #ff9800',     // 🔥 border orange
                  '&:hover': {
                    backgroundColor: '#001B44',
                    border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                    color: '#ffa726'
                  }
                }}
                onClick={() => navigate(-1)}>
                Odustani
              </Button>

              <Button variant="outlined"
                sx={{
                  minWidth: 100,
                  backgroundColor: '#001B44',
                  color: '#ff9800',                // 🔥 tekst orange
                  border: '1px solid #ff9800',     // 🔥 border orange
                  '&:hover': {
                    backgroundColor: '#001B44',
                    border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                    color: '#ffa726'
                  }
                }}
                onClick={updateAPIData}
              >
                Spasi
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </div >
  );
}
